/* Picks the Watercraft homepage banner for the viewport.
   1a and 1b are separate assets rather than one responsive layout — 1a
   carries a 540px card wall, 1b a scroll-snap card row — so only one is
   mounted rather than rendering both and hiding one with CSS. */
import React, { useEffect, useState } from 'react';
import WatercraftBanner from './WatercraftBanner';
import WatercraftBannerMobile from './WatercraftBannerMobile';

const MOBILE_QUERY = '(max-width: 767px)';

function useIsMobile() {
  // Read synchronously on mount so the wrong variant never paints first.
  const [isMobile, setIsMobile] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(MOBILE_QUERY).matches
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    // Safari below 14 only has the deprecated listener API.
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, []);

  return isMobile;
}

export default function WatercraftHomepageBanner() {
  return useIsMobile() ? <WatercraftBannerMobile /> : <WatercraftBanner />;
}
